import type { RoutesTreeItem } from 'containers/App/Routes/RoutesTreeItem';
import { UserProfilePage } from 'pages/Me/UserProfile/UserProfilePage';
import { NotFoundPage } from 'pages/NotFoundPage/NotFoundPage';

export const meRoutes: RoutesTreeItem[] = [
  {
    path: '/me/profile',
    element: <UserProfilePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];
